import { z } from "zod";

import { DocumentAttributeWiringSchema, migrateBorderUsAttributeWiring } from "~/shared/documents/schemas/document-attribute-wiring.schema";
import { DocumentDisplayUomSettingsSchema } from "~/shared/documents/schemas/document-display-uom.schema";
import { AllowTypedSignatureSettingsSchema } from "~/shared/documents/schemas/typed-signature.schema";
import { EditorSchema, emptyEditorDoc } from "~/utils/types/rich-text";

/** border-us slug — org settings config stored at ORDER_DOCUMENT_CONFIG:border-us */
export const BorderUsDocumentConfigObjectSchema = z
  .object({
    header: EditorSchema.default(emptyEditorDoc()),
    customsNotify: EditorSchema,
    declarationOfShipper: EditorSchema,
    attributeWiring: DocumentAttributeWiringSchema.transform(migrateBorderUsAttributeWiring),
  })
  .merge(DocumentDisplayUomSettingsSchema)
  .merge(AllowTypedSignatureSettingsSchema);

export const BorderUsDocumentConfigSchema = BorderUsDocumentConfigObjectSchema;

export type BorderUsDocumentConfig = z.infer<typeof BorderUsDocumentConfigSchema>;
